import React, { useMemo, useState } from 'react'

import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { Button } from 'ziphy-web-shared/basic/lib/buttons'
import { useForm } from 'ziphy-web-shared/basic/lib/forms'
import { DateInput, LegacyInput } from 'ziphy-web-shared/basic/lib/forms/fields'
import MultiSelect from 'ziphy-web-shared/basic/lib/forms/fields/multiSelect/LegacyMultiSelect'
import { ConnectedGroup } from 'ziphy-web-shared/basic/lib/simple'

import { $psHistory } from '@store'

const DocumentsSearch = () => {
  const { t } = useTranslation()

  const [showFilters, setShowFilters] = useState(false)

  const { minDate, maxDate } = $psHistory.eventsMinMaxDate

  const { form, useFormOnChange } = useForm({
    searchString: { store: $psHistory }, // SET_SEARCH_STRING
    dateFrom: { store: $psHistory }, // SET_DATE_FROM
    dateTo: { store: $psHistory }, // SET_DATE_TO
    sortBy: { store: $psHistory, prepValue: 'singleSelect' }, // SET_SORT_BY
    showMore: { store: $psHistory, prepValue: 'singleSelect' }, // SET_SHOW_MORE
  })
  const { searchString, dateFrom, dateTo, sortBy, showMore } = form.fields

  useFormOnChange(async () => await $psHistory.searchEvents(), [searchString.value])

  const sortByItems = useMemo(() => {
    return [
      { id: 'date_desc', text: t('ps.label.sortBy.date_desc') },
      {
        id: 'date_asc',
        text: t('ps.label.sortBy.date_asc'),
      },
    ]
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="pd-search-params mb-20">
      <div className="row">
        <div className="col-12 col-lg-4 pd-search-params-filters--input">
          <LegacyInput
            type="search"
            field={searchString}
            label={t('ps.label.search')}
            placeholder={t('ps.ph.search_details')}
            clear
          />
        </div>
        <div className="col-12 col-lg-auto pd-search-params-filters--btn">
          <Button
            mode={['custom-filters']}
            isActive={showFilters}
            leftElement={'list'}
            onClick={() => setShowFilters((x) => !x)}
          >
            {t('btn.filters')}
          </Button>
        </div>
      </div>
      {showFilters && (
        <div className="row mt-20">
          <div className="col-12 col-lg-4">
            <ConnectedGroup
              renderItems={[
                ({ getClass }) => (
                  <DateInput
                    field={dateFrom}
                    minDate={minDate}
                    maxDate={maxDate}
                    type={'selectDateTime'}
                    label={t('label.date_from')}
                    placeholder={t('ps.ph.date_from')}
                    mode="sm"
                    readonly={true}
                    clear={true}
                    innerClassName={getClass()}
                  />
                ),
                ({ getClass }) => (
                  <DateInput
                    field={dateTo}
                    minDate={minDate}
                    maxDate={maxDate}
                    label={t('label.date_to')}
                    placeholder={t('ps.ph.date_to')}
                    mode="sm"
                    readonly={true}
                    clear={true}
                    innerClassName={getClass()}
                  />
                ),
              ]}
            />
          </div>
          <div className="col-12 col-lg-4">
            <MultiSelect
              label={t('ps.label.sortBy')}
              items={sortByItems}
              field={sortBy}
              mode={['sm', 'fw-400']}
            />
          </div>
          <div className="col-12 col-lg-4">
            <MultiSelect
              label={t('ps.label.view_details')}
              field={showMore}
              items={[
                { id: 'less', text: t('ps.label.collapse_all') },
                { id: 'more', text: t('ps.label.show_all') },
              ]}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default observer(DocumentsSearch)
